import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50ed3ed0")

_pushScopeId("data-v-50ed3ed0")
const _hoisted_1 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_2 = { class: "kn-list-item" }
const _hoisted_3 = { class: "kn-list-item-text" }
const _hoisted_4 = { class: "kn-list-item-text-secondary kn-truncated" }
const _hoisted_5 = { class: "p-col-6 p-p-0 p-m-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Card = _resolveComponent("Card")
  const _component_BuisnessModelDriverDetail = _resolveComponent("BuisnessModelDriverDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "p-col-6 p-p-0" }, {
      header: _withId(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.drivers')), 1)
          ]),
          end: _withId(() => [
            _createVNode(_component_Button, {
              class: "kn-button p-button-text",
              disabled: _ctx.readonly,
              onClick: _ctx.showForm
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.add')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      content: _withId(() => [
        _createVNode(_component_Listbox, {
          class: "kn-list",
          options: _ctx.businessModelDrivers,
          listStyle: "max-height:calc(100% - 62px)",
          onChange: _ctx.showForm,
          "data-test": "driver-list"
        }, {
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withId((slotProps) => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", {
                  class: {
                                        'driver-invalid': slotProps.option.numberOfErrors > 0
                                    }
                }, _toDisplayString(slotProps.option.label), 3),
                _createVNode("span", _hoisted_4, _toDisplayString(slotProps.option.parameterUrlName), 1)
              ]),
              (slotProps.option.id !== _ctx.businessModelDrivers[0].id && !_ctx.readonly)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "fa fa-arrow-up",
                    class: "p-button-link p-button-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.movePriority(slotProps.option.id, 'UP')), ["stop"])
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (slotProps.option.id !== _ctx.businessModelDrivers[_ctx.businessModelDrivers.length - 1].id && !_ctx.readonly)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "fa fa-arrow-down",
                    class: "p-button-link p-button-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.movePriority(slotProps.option.id, 'DOWN')), ["stop"])
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.readonly)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    icon: "far fa-trash-alt",
                    class: "p-button-link p-button-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteDriverConfirm(slotProps.index)), ["stop"])
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["options", "onChange"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_BuisnessModelDriverDetail, {
        businessModelId: _ctx.id,
        selectedDriver: _ctx.selectedDriver,
        formVisible: _ctx.formVisible,
        driverOptions: _ctx.analyticalDrivers,
        businessModelDrivers: _ctx.businessModelDrivers,
        readonly: _ctx.readonly
      }, null, 8, ["businessModelId", "selectedDriver", "formVisible", "driverOptions", "businessModelDrivers", "readonly"])
    ])
  ]))
})